import { useMemo } from "react";
import { type SelectProps } from "antd";
import "./party-suggestion.scss";
import { UserInfo } from "../../../../project/api/get-project-user";
import { UserSelectOption, UserSelect } from "./index.ts";

// TODO : разобраться в типах
// перенести в project, или что-то ещё
interface UserSuggestionsProps extends SelectProps {
  onUserSelect: (party: UserInfo) => void;
  users: Array<UserInfo>;
}

export function UserSuggestions({
  onUserSelect,
  users,
  ...rest
}: UserSuggestionsProps) {
  const onSelect = (value: string) => {
    const selected = users.find((el) => el.userId === value);
    if (selected) {
      onUserSelect(selected);
    }
  };

  const options = useMemo(
    () =>
      users.map((val) => {
        return {
          value: val.userId,
          label: <UserSelectOption value={val} />,
          inputLabel: [val.userSurname, val.userFirstName, val.userMiddleName]
            .filter(Boolean)
            .join(" "),
          className: "party-suggestion",
        };
      }),
    [users],
  );

  return <UserSelect onSelect={onSelect} options={options} {...rest} />;
}
